// extracted by mini-css-extract-plugin
export default {"h1":"UnpaidLicense_h1__5eibE","circularProgressBox":"UnpaidLicense_circularProgressBox__TuNBs"};